import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../../components/imports'

import { APP_NAME, PLANTSITTING_COM, PLANTSITTING_COM_PER } from '../../constants/general'

import PlantSitting from '../../class/PlantSitting';
import { useForm } from 'react-hook-form';
import { Context } from '../../class/Context';
import Func from '../../class/Func';

function PlantSittingReserver() {

    const { id } = useParams()

    const navigate = useNavigate()

    const context = useContext(Context)

    const [annonce, setAnnonce] = useState(false)

    const [loading, setLoading] = useState(true)

    const [date_debut, setDate_debut] = useState(false)

    const [date_fin, setDate_fin] = useState(false)

    const [nbrJours, setNbrJours] = useState(0)

    const [jours, setJours] = useState(0)

    const [semaines, setSemaines] = useState(0)

    const [nbr_plantes, setNbr_plantes] = useState(0)

    const [prestation, setPrestation] = useState(0)

    const [prixUnitaire, setPrixUnitaire] = useState(0)

    const [prix, setPrix] = useState(0)

    const {
        register,
        handleSubmit,
        setError,
        formState: { errors, isSubmitting }
    } = useForm()

    const onSubmit = async (data) => {

        if (annonce.categorie_id == 1) {
            // alert('vous devez choisir un nombre de jours : ', jours)
            data.nbrjours = jours
        }

        let results = await PlantSitting.post('reserver', {
            annonce_id: id,
            date_debut: data.date_debut,
            date_fin: data.date_fin,
            reservation: data.reservation,
            description: data.description,
            nbrjours: data.nbrjours ?? 0,
            lieu: data.lieu ?? null,
            logement: data.logement ?? null,
            taille: data.taille ?? null,
            type: data.type ?? null
        })

        if (results.success) {

            navigate('/mon-profile/discussion/' + results.discussion_id)

        } else {

            setError('err', { message: results.message })

        }

    }

    const changeNbr_plantes = (choix, prix) => {

        setPrixUnitaire(prix)

        setNbr_plantes(choix)

        setPrix(prix * nbrJours)

    }

    const changePrestation = (choix, prix) => {

        setPrixUnitaire(prix)

        setPrestation(choix)

        setPrix(prix * nbrJours)

    }

    const changeNbr_jours = (nbr) => {

        setNbrJours(nbr)

        setPrix(prixUnitaire * nbr)

    }

    const changeDate = (date, type = 'debut') => {

        if (type == 'debut') {

            setDate_debut(date)

            nombreDeJours(date, date_fin)

        }

        if (type == 'fin') {

            setDate_fin(date)

            nombreDeJours(date_debut, date)

        }

    }

    const getAnnonce = async (id) => {

        window.scrollTo(0, 0)

        let results = await PlantSitting.post('annonceById', { id: id })

        setLoading(false)

        if (results.success) {

            setAnnonce(results.data)

        } else {

            navigate('/404')

        }

    }

    function nombreDeJours(date_debut, date_fin) {

        if (!date_debut || !date_fin) return false

        // Convertir les entrées en objets Date (si ce ne sont pas déjà des objets Date)
        const debut = new Date(date_debut);
        const fin = new Date(date_fin);

        if (annonce.categorie_id == 3 && date_fin != 0) {
            fin.setDate(fin.getDate() + 1)
        }

        // Vérifier que les dates sont valides
        if (isNaN(debut) || isNaN(fin)) return false

        // Calculer la différence en millisecondes
        const diffTemps = fin.getTime() - debut.getTime();

        // Convertir les millisecondes en jours
        const diffJours = Math.ceil(diffTemps / (1000 * 60 * 60 * 24));

        if (diffJours > 0) {
            setJours(diffJours)
            if (annonce.categorie_id == 1) {
                changeNbr_jours(diffJours)
            }
            if (annonce.categorie_id == 3) {
                setSemaines(diffJours)
            } else {
                setSemaines(Math.ceil(diffJours / 7))
            }
        } else {
            alert('choisi de bonnes dates')
        }

    }

    useEffect(() => {

        Func.session(context, navigate, '/connexion', true)

        getAnnonce(id)

        document.title = "Réserver un plant sitter - " + APP_NAME

    }, [])

    return (

        <div>

            <Header />

            <div className="plantsitting">

                <HeaderBox />

                <div className="single">

                    <div className='content'>

                        {

                            !loading

                                ?

                                <div className='c'>

                                    <form className='gla-form' method='POST' onSubmit={handleSubmit(onSubmit)}>
                                        <div class="bg7 br8 p20 mt20 mb20">

                                            {annonce.categorie_id == 1 && <p className='fw5 fz13'>Je réserve un gardiennage</p>}
                                            {annonce.categorie_id == 2 && <p className='fw5 fz13'>Je réserve un arrosage</p>}
                                            {annonce.categorie_id == 3 && <p className='fw5 fz13'>Je réserve un jardinage</p>}

                                            {errors.err && <p className="error">{errors.err.message}</p>}

                                            {
                                                annonce.categorie_id == 1

                                                &&

                                                <label className='mt20'>
                                                    <span>Localisation : {annonce.ville}</span>

                                                    <div class="col-65 m_col_10"></div>
                                                </label>

                                            }

                                            <label className='mt20'>
                                                <span>Date de début</span>

                                                <div class="col-65 m_col_10">
                                                    <div className="flex mb10 jc-start">
                                                        <input type="date" {...register("date_debut")} onChange={(e) => changeDate(e.target.value, 'debut')} required={true} />
                                                    </div>
                                                </div>
                                            </label>

                                            <label>
                                                <div className='col-3 m_mb_30'>
                                                    <span>Date de fin</span>

                                                    {/* {annonce.categorie_id == 3 && jours > 0 && <p className='fz08'>{jours} jours</p>} */}
                                                    {jours > 0 && <p className='fz08'>{jours} jours</p>}
                                                    {/* {annonce.categorie_id == 1 && annonce.categorie_id == 2 && semaines > 0 && <p className='fz08'>{semaines} semaines</p>} */}

                                                    {/* {semaines > 0 && <p className='fz08'>{semaines} semaines</p>} */}
                                                </div>


                                                <div class="col-65 m_col_10">
                                                    <div className="flex mb10 jc-start">
                                                        <input type="date" {...register("date_fin")} onChange={(e) => changeDate(e.target.value, 'fin')} min={date_debut} required={true} />
                                                    </div>
                                                </div>
                                            </label>

                                            {

                                                (annonce.categorie_id == 2 || annonce.categorie_id == 3)

                                                &&

                                                <label>
                                                    <span>Lieu approximatif</span>

                                                    <div class="col-65 m_col_10">
                                                        <div className="flex mb10 jc-start">
                                                            <input type="text" {...register("lieu")} placeholder="Ex: j'habite Paris quartier des batignolles" required={true} />
                                                        </div>
                                                    </div>
                                                </label>

                                            }

                                            {

                                                annonce.categorie_id == 3

                                                &&

                                                <label>
                                                    <span>Taille du jardin (m²)</span>

                                                    <div class="col-65 m_col_10">
                                                        <div className="flex mb10 jc-start">
                                                            <input type="number" {...register("taille")} placeholder="Ex: 50" required={true} />
                                                        </div>
                                                    </div>
                                                </label>

                                            }

                                            <div className='mb20'></div>

                                            {

                                                (annonce.categorie_id == 1 || annonce.categorie_id == 2)

                                                &&

                                                <label className='m_mt_40'>

                                                    <div className='col-3 m_mb_30'>
                                                        <span>Nombre de plantes</span>
                                                        <p className='fz08 m_mt_10'>Tarif par jour.</p>
                                                    </div>

                                                    <div class="col-65 m_col_10 m_mt_10">
                                                        {
                                                            annonce.tarif1 > 0

                                                            &&

                                                            <div className="flex mb10 jc-start m_flex">
                                                                <input type="radio" {...register("reservation")} value={1} checked={nbr_plantes == 1} onChange={() => changeNbr_plantes(1, annonce.tarif1)} />
                                                                <p class='fz09 ml10'>Entre 1 & 30 plantes {annonce.tarif1} €</p>
                                                            </div>

                                                        }

                                                        {
                                                            annonce.tarif2 > 0

                                                            &&
                                                            
                                                            <div className="flex mb10 jc-start m_flex">
                                                                <input type="radio" {...register("reservation")} value={2} checked={nbr_plantes == 2} onChange={() => changeNbr_plantes(2, annonce.tarif2)} />
                                                                <p class='fz09 ml10'>Supérieur à 30 plantes {annonce.tarif2} €</p>
                                                            </div>

                                                        }
                                                    </div>
                                                </label>

                                            }

                                            <label className='m_mt_40'>
                                                <span>Nombre de jours</span>

                                                <div class="col-65 m_col_10">
                                                    <div className="flex mb10 jc-start">

                                                        {

                                                            (annonce.categorie_id == 1)

                                                                ?

                                                                <input type="number" {...register("nbrjours")} placeholder="Ex: 2" required={true} value={jours} min={jours} max={jours} />

                                                                :

                                                                <input type="number" {...register("nbrjours")} placeholder="Ex: 2" required={true} min={1} max={jours} onChange={(e) => changeNbr_jours(e.target.value)} />


                                                        }
                                                    </div>
                                                </div>

                                            </label>

                                            {

                                                (annonce.categorie_id == 2)

                                                &&

                                                <>

                                                    {/* <label className='m_mt_40'>
                                                        <span>Nombre de passages</span>

                                                        <div class="col-65 m_mt_10">

                                                            {
                                                                annonce.categorie_id == 2

                                                                &&

                                                                <div className="flex mb10 jc-start m_flex">
                                                                    <input type="radio" {...register("passages")} value={annonce.frequence} checked={passages == annonce.frequence} onChange={() => setPassages(annonce.frequence)} />
                                                                    <p class='fz09 ml10'>{ annonce.frequence == 1 ? '1 passage' : '2 passages' }</p>
                                                                </div>

                                                            }

                                                            {/* <div className="flex mb10 jc-start m_flex">
                                                                <input type="radio" {...register("passages")} value={1} checked={passages == 1} onChange={() => setPassages(1)} />
                                                                <p class='fz09 ml10'>1 passage</p>
                                                            </div>
                                                            <div className="flex mb10 jc-start m_flex">
                                                                <input type="radio" {...register("passages")} value={2} checked={passages == 2} onChange={() => setPassages(2)} />
                                                                <p class='fz09 ml10'>2 passages</p>
                                                            </div> }
                                                        </div>
                                                    </label> */}

                                                    <label className='m_mt_40'>
                                                        <span>Type de logement</span>

                                                        <div class="col-65 m_col_10 m_mt_10">
                                                            <div className="flex mb10 jc-start m_flex">
                                                                <input type="radio" {...register("logement")} value={'maison'} required={true} />
                                                                <p class='fz09 ml10'>Maison</p>
                                                            </div>
                                                            <div className="flex mb10 jc-start m_flex">
                                                                <input type="radio" {...register("logement")} value={'appartement'} />
                                                                <p class='fz09 ml10'>Appartement (prérise l'étage en description)</p>
                                                            </div>
                                                        </div>
                                                    </label>

                                                    <label className='m_mt_40'>
                                                        <span>Type d'arrosage</span>

                                                        <div class="col-65 m_mt_10">
                                                            <div className="flex mb10 jc-start m_flex">
                                                                <input type="radio" {...register("type")} value={'interieur'} required={true} />
                                                                <p class='fz09 ml10'>Intérieur</p>
                                                            </div>
                                                            <div className="flex mb10 jc-start m_flex">
                                                                <input type="radio" {...register("type")} value={'exterieur'} />
                                                                <p class='fz09 ml10'>Extérieur</p>
                                                            </div>
                                                            <div className="flex mb10 jc-start m_flex">
                                                                <input type="radio" {...register("type")} value={'les deux'} />
                                                                <p class='fz09 ml10'>Les deux</p>
                                                            </div>

                                                        </div>
                                                    </label>

                                                </>

                                            }

                                            {

                                                (annonce.categorie_id == 3)

                                                &&

                                                <label>

                                                    <span>Prestation (Tarif indicatif)</span>

                                                    <div class="col-65 fw4 m_mt_20">
                                                        {annonce.tarif1 > 0 &&
                                                            <div className="flex mb10 jc-start m_flex">
                                                                <input type="radio" {...register("reservation")} value={1} checked={prestation == 1} onChange={e => changePrestation(1, annonce.tarif1)} required={true} />
                                                                <p class='fz09 ml10'>Tondre {annonce.tarif1} €</p>
                                                            </div>
                                                        }
                                                        {annonce.tarif2 > 0 &&
                                                            <div className="flex mb10 jc-start m_flex">
                                                                <input type="radio" {...register("reservation")} value={2} checked={prestation == 2} onChange={e => changePrestation(2, annonce.tarif2)} />
                                                                <p class='fz09 ml10'>Tailler {annonce.tarif2} €</p>
                                                            </div>
                                                        }
                                                        {annonce.tarif3 > 0 &&
                                                            <div className="flex mb10 jc-start m_flex">
                                                                <input type="radio" {...register("reservation")} value={3} checked={prestation == 3} onChange={e => changePrestation(3, annonce.tarif3)} />
                                                                <p class='fz09 ml10'>Nettoyer et Autre {annonce.tarif3} €</p>
                                                            </div>
                                                        }
                                                        {/* <div className="flex mb10 jc-start m_flex">
                                                            <input type="radio" {...register("reservation")} value={1} checked={prestation == 1} onChange={e => changePrestation(1, annonce.tarif1)} required={true} />
                                                            <p class='fz09 ml10'>Tondre {annonce.tarif1} €</p>
                                                        </div>
                                                        <div className="flex mb10 jc-start m_flex">
                                                            <input type="radio" {...register("reservation")} value={2} checked={prestation == 2} onChange={e => changePrestation(2, annonce.tarif2)} />
                                                            <p class='fz09 ml10'>Tailler {annonce.tarif2} €</p>
                                                        </div>
                                                        <div className="flex mb10 jc-start m_flex">
                                                            <input type="radio" {...register("reservation")} value={3} checked={prestation == 3} onChange={e => changePrestation(3, annonce.tarif3)} />
                                                            <p class='fz09 ml10'>Nettoyer et Autre {annonce.tarif3} €</p>
                                                        </div> */}
                                                    </div>

                                                </label>

                                            }

                                            <label>
                                                <div className='col-3 m_mb_30'>
                                                    <span>Conseignes spécifiques</span>
                                                    <p className='fz08 m_mt_10'>Merci de fournir une description précise de ta demande afin de permettre à l’utilisateur d’ajuster son tarif en conséquence et d’assurer une bonne compréhension mutuelle.</p>
                                                </div>
                                                <textarea {...register("description")} placeholder="Je souhaite que vous chouchoutiez mes plantes pendant que je suis en vacances, le lundi, mardi et vendredi" required="true" ></textarea>
                                            </label>

                                        </div>

                                        <div class="flex bg7 br8 p20 mt20 ai-start">

                                            <div>
                                                <p className='fz15 fw5'>{prix} €</p>
                                                {prix > 0 &&
                                                    <p class="fz09"><span class="icon cl4 mr5 mt3" style={{ position: 'relative', top: 'unset', left: 'unset' }}>a</span><span className='cl4'>{(prix) + (prix * PLANTSITTING_COM_PER) + PLANTSITTING_COM}€ frais de service inclus</span></p>}
                                                <p class="fz09">L’utilisateur pourra ajuster le tarif en fonction de tes besoins</p>
                                            </div>

                                            <input type="submit" name="submit" value="Envoyer une demande" class="btn bg4 cl5 brc4 brc1solid m_mt_20 m_col_10" disabled={isSubmitting} style={{ opacity: isSubmitting ? '0.2' : '1' }} />

                                        </div>

                                    </form>

                                </div>

                                :

                                <div className='flex jc-center mt50 mb50'>
                                    <div className="lds-dual-ring col"></div>
                                </div>

                        }

                    </div>

                </div>

                <Footer />

            </div >

        </div >

    )

}

export default PlantSittingReserver